<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M10 17V8" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="10" cy="3" r="1" fill="#202830"/>
    </svg>
</template>

<script>
export default {
    name: 'IconInfo',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
